<template>
  <div :class="bemBlock">
    <div ref="products" v-dragscroll :class="bemElement('products')">
      <div ref="main" :class="bemElement('main')" :style="cssCustomProps">
        <TheProductCustomizerComplementVisualizer
          v-for="(complement, i) in uiComplementProducts"
          :key="i"
          :complement="complement"
          :edit-mode="editMode"
          @complement-visualizer:show="scrollToRight"
          @complement-visualizer:remove="
            handleComplementRemove($event, complement, i)
          "
        />
      </div>
    </div>
    <button
      v-if="editMode || uiComplementProducts.length"
      :class="bemElement('edit')"
      @click="toggleEditMode"
    >
      {{ editButtonText }}
    </button>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { dragscroll } from 'vue-dragscroll';
import bemClassesMixin from '../../mixins/bemClassesMixin';
import TheProductCustomizerComplementVisualizer from './TheProductCustomizerComplementVisualizer.vue';
import { types, getters } from '../../store';
import getAnalyticsEventBus from '../../../common/getAnalyticsEventBus';
import getFrontConfig from '../../../common/getFrontConfig';
import EventBusConfig from '../../config/eventBusConfig';
import {
  getParameterValueFromRequest,
  isWebPlatform,
} from '../../../common/utils/api';
import { editCustomizer as editCustomizerAppsCallback } from '../../../components/home/appLib';

const { apiConfig } = getFrontConfig();

const analyticsEventBus = getAnalyticsEventBus();

const {
  customizerConfig,
  urls: { customizerResources },
} = getFrontConfig();

export default {
  name: 'TheProductCustomizerVisualizer',

  components: {
    TheProductCustomizerComplementVisualizer,
  },

  directives: {
    dragscroll,
  },

  mixins: [bemClassesMixin],

  data() {
    return {
      editMode: false,
    };
  },

  computed: {
    ...mapGetters({
      customizerId: getters.productCustomizer.customizerId,
      mainProducts: getters.productCustomizer.mainProducts,
      uiComplementProducts: getters.productCustomizer.uiComplementProducts,
      uiMainProduct: getters.productCustomizer.uiMainProduct,
    }),
    ...mapState({
      isRemovingComplement: (state) =>
        state.productCustomizer.isRemovingComplement,
    }),
    cssCustomProps() {
      const visualizerBorder =
        customizerConfig?.[this.customizerId]?.visualizerBorder || {};
      return {
        '--main-bg-image': `url("${this.imageUrl}")`,
        ...visualizerBorder,
      };
    },
    editButtonText() {
      return this.editMode
        ? this.$msg('button.cancel', 'customizer')
        : this.$msg('button.edit', 'customizer');
    },
    imageUrl() {
      let imageName = '';
      if (this.uiMainProduct) {
        imageName = `${customizerResources}${
          this.customizerId
        }/${this.uiMainProduct?.replaceAll('.', '_')}.png`;
      } else if (this.mainProducts?.length > 0) {
        imageName = `${customizerResources}${
          this.customizerId
        }/${this.mainProducts[0].id?.replaceAll('.', '_')}.png`;
      }
      return imageName;
    },
    isAppRequest() {
      const platform = getParameterValueFromRequest(
        apiConfig.PLATFORM_PARAMETER_NAME
      );
      return !isWebPlatform(platform);
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.scrollToRight();
    });
  },

  methods: {
    handleComplementRemove($event, complement, index) {
      this.$store.commit(types.productCustomizer.isRemovingComplement);
      this.$store.dispatch(types.productCustomizer.removeUIComplementProduct, {
        productId: complement,
        index,
      });
      this.$eventBus.$emit(
        EventBusConfig.commands.TheProductCustomizer.removeComplement,
        complement
      );
    },
    scrollToRight() {
      if (!this.isRemovingComplement) {
        const mainWidth = this.$refs.main.getBoundingClientRect().width;
        this.$refs.products.scrollLeft = mainWidth + 32;
      }
    },
    toggleEditMode() {
      this.editMode = !this.editMode;
      if (this.editMode) {
        if (this.isAppRequest) {
          // Click on Edit link Analytics method for APP's
          editCustomizerAppsCallback(this.customizerId);
          return;
        }
        // Click on Edit link Analytics event
        analyticsEventBus.publish(
          analyticsEventBus.EVENTS.productCustomizerEditionStarted,
          {
            customizerId: this.customizerId,
          }
        );
      }
    },
  },
};
</script>
